import ExamImage from "../../components/ExamImage";
export default function MatchingWidget({
  blanks,
  options,
  compact,
  value = {},
  onChange,
  mode,
  feedback
}) {
  const ROW_MIN_HEIGHT = compact ? 50 : 150;
  const IMAGE_WIDTH = 150;
  const IMAGE_HEIGHT = 150;

  const showFeedback = Boolean(feedback?.parts);

  function setBlank(id, v) {
    if (mode !== "edit" || showFeedback) return;
    onChange({ ...value, [id]: v.toUpperCase() });
  }

  function ImageBox({ src, alt, border }) {
    return (
      <div
        style={{
          width: IMAGE_WIDTH,
          height: IMAGE_HEIGHT,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}
      >
        <ExamImage
          src={src}
          alt={alt}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            border: border ?? "1px solid #ccc",
            borderRadius: 6
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 100,
        alignItems: "start"
      }}
    >
      {/* LEFT: blanks */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {blanks.map((b) => {
          const showImage = !!b.src;

          const part = feedback?.parts?.[b.id];
          const expected = part?.expected;
          const received = part?.received;

          const isCorrect = showFeedback && part?.correct;
          const isWrong = showFeedback && !part?.correct;

          return (
            <div
              key={b.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                minHeight: ROW_MIN_HEIGHT
              }}
            >
              {/* INPUT */}
              <input
                type="text"
                maxLength={2}
                value={value[b.id] || ""}
                onChange={(e) => setBlank(b.id, e.target.value)}
                disabled={mode !== "edit" || showFeedback}
                style={{
                  width: 48,
                  height: 40,
                  textAlign: "center",
                  fontSize: 16,
                  borderRadius: 6,
                  flexShrink: 0,
                  border: isCorrect
                    ? "2px solid green"
                    : isWrong
                    ? "2px solid red"
                    : "2px solid #333",
                  background: showFeedback ? "#fafafa" : "white"
                }}
              />

              {/* IMAGE OR LABEL */}
              {showImage ? (
                <ImageBox
                  src={b.src}
                  alt={b.alt || b.label || b.id}
                  border="none"
                />
              ) : (
                <span
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    lineHeight: 1.3
                  }}
                >
                  {b.label}
                </span>
              )}

              {/* OPTIONAL: show correct answer when wrong
              {showFeedback && isWrong && (
                <span
                  style={{
                    marginLeft: 8,
                    fontSize: 14,
                    color: "#555"
                  }}
                >
                  → {expected}
                </span>
              )} */}
            </div>
          );
        })}
      </div>

      {/* RIGHT: options */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {options.map((opt, i) => {
          const letter =
            opt.id ?? opt.value ?? String.fromCharCode(65 + i);
          const showImage = !!opt.src;

          return (
            <div
              key={letter}
              style={{
                display: "grid",
                gridTemplateColumns: showImage ? "28px auto" : "28px 1fr",
                columnGap: 8,
                alignItems: "center",
                minHeight: ROW_MIN_HEIGHT
              }}
            >
              <strong>{letter}.</strong>

              {showImage ? (
                <ImageBox
                  src={opt.src}
                  alt={opt.alt || opt.label || letter}
                />
              ) : (
                <span
                  style={{
                    fontSize: 14,
                    lineHeight: 1.35
                  }}
                >
                  {opt.label}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
